<div class="attachments-container">
  <div
    class="card"
    [ngClass]="{ 'classic-style': classicStyles }"
    *ngFor="let url of urls; let i = index"
  >
    <div class="thumbnail-wrapper" (click)="onThumbnailClick(i)">
      <img *ngIf="isImage(url)" [src]="url" [alt]="getFileName(url, i)" />
      <img
        *ngIf="isPDF(url) && pdfThumbnails[url]"
        [src]="pdfThumbnails[url]"
        [alt]="getFileName(url, i)"
      />
      <img
        *ngIf="isPDF(url) && !pdfThumbnails[url]"
        src="assets/logo.pdf.png"
        alt="PDF placeholder"
      />
    </div>
    <div class="file-info">
      <div class="file-name" [title]="getFileName(url, i)">{{ getFileName(url, i) }}</div>
    </div>
    <button
      type="button"
      class="delete-btn"
      (click)="onDeleteClick(i, $event)"
      title="Remove file"
      *ngIf="!readOnly"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>
